import axios from "axios";
import store from "../Store";
import Config from "./Config";
import { encrypt } from "./Crypto";
import { getCookie } from "./Utils";
import { authChange } from "../Reducer/componentSlice";

const ApiCall = axios.create({
    baseURL: Config.URL.BACKEND_URL,
    timeout: 20000,
    headers: { "Content-Type": "application/json" },
});

ApiCall.interceptors.request.use(
    (config) => {
        const token = getCookie("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (config?.formdata) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else if (["post", "patch", "put"].includes(String(config?.method).toLowerCase())) {
            config.data = encrypt(config?.data);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

ApiCall.interceptors.response.use(
    (response) => response.data,
    (error) => {
        const status = error?.response?.status;
        if ((status === 401 || status === 403) && !error?.config?.silent) {
            store?.dispatch(authChange(false));
        }
        return Promise.reject(error);
    }
);

export default ApiCall;
